import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export const BrandStatement = () => {
  const imgRef = useRef(null);
  const { scrollYProgress } = useScroll({ target: imgRef, offset: ["start end", "end start"] });
  const parallaxY = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  return (
  <section data-testid="brand-statement-section" className="max-w-7xl mx-auto px-6 md:px-10 py-28 md:py-40">
    <Reveal>
      <p className="text-xs font-medium tracking-[0.25em] uppercase text-[#2C241E]/50">
        01 / Philosophy
      </p>
    </Reveal>
    <div data-testid="brand-statement-text" className="mt-10">
      <Reveal delay={0.05}>
        <h2 className="font-display text-4xl md:text-7xl tracking-tighter leading-[1.05] text-[#2C241E]">
          Support wear hasn't
        </h2>
      </Reveal>
      <Reveal delay={0.12}>
        <h2 className="font-display text-4xl md:text-7xl tracking-tighter leading-[1.05] text-[#2C241E] md:pl-24">
          changed in <span className="italic text-[#A07856]">decades.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.19}>
        <h2 className="font-display text-4xl md:text-7xl tracking-tighter leading-[1.05] text-[#2C241E]">
          Support should feel as
        </h2>
      </Reveal>
      <Reveal delay={0.26}>
        <h2 className="font-display text-4xl md:text-7xl tracking-tighter leading-[1.05] text-[#2C241E] md:pl-40">
          good as it <span className="italic">looks.</span>
        </h2>
      </Reveal>
    </div>
    <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
      <Reveal className="md:col-span-4" delay={0.3}>
        <div ref={imgRef} className="rounded-2xl overflow-hidden aspect-[4/3]">
          <motion.img
            src="/renders/walk-b.png"
            alt="Athlete mid-stride in a mocha LIGATEN knee brace"
            loading="lazy"
            style={{ y: parallaxY, scale: 1.18 }}
            className="w-full h-full object-cover"
          />
        </div>
      </Reveal>
      <Reveal className="md:col-span-5 md:col-start-8" delay={0.35}>
        <p className="text-base md:text-lg leading-relaxed text-[#2C241E]/70">
          LIGATEN is the first recovery-wear brand designed like a lifestyle product — not
          medical equipment. Every piece is shaped by a physiotherapist in Australia, so it
          moves the way you do and looks like it belongs. The knit is odourless and itch-free —
          made for skin, not clinics.
        </p>
      </Reveal>
    </div>
    <Reveal delay={0.4}>
      <Link
        to="/philosophy"
        data-testid="philosophy-link"
        className="mt-12 inline-flex items-center gap-2 text-xs md:text-sm font-medium tracking-[0.2em] uppercase text-[#2C241E]/70 transition-colors duration-200 hover:text-[#2C241E]"
      >
        Read the philosophy
        <ArrowRight size={16} strokeWidth={1.75} />
      </Link>
    </Reveal>
  </section>
  );
};
